const today = new Date().toLocaleDateString('fr-CA');

export default today;
